import { Button } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import { HiPlus } from 'react-icons/hi';
import ClientApi from '../../Api/ClientApi';
import { ClientLocation } from '../../Models/ClientLocation';
import ClientLocationListTable from './ClientLocationListTable';
import ClientLocationModal from './ClientLocationModal';

export default function ClientLocationList({ clientId }: { clientId: number }) {
  const { userModel } = useAppSelector((state) => state.user);
  const [locationListData, setLocationListData] = useState<ClientLocation[]>(
    []
  );
  const [selectedClientLocation, setSelectedClientLocation] =
    useState<ClientLocation | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const getClientLocations = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ClientApi.getClientLocationsForClient(clientId)
          .then((res) => {
            setLocationListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [clientId]);

  useEffect(() => {
    getClientLocations();
  }, [getClientLocations]);

  const handleAddClientLocationClick = () => {
    setSelectedClientLocation(null);
    setShowModal(true);
  };

  const editClientLocation = (location: ClientLocation) => {
    setSelectedClientLocation(location);
    setShowModal(true);
  };

  function deleteClientLocation(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      ClientApi.deleteClientLocation(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getClientLocations();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Button
              onClick={handleAddClientLocationClick}
              className='buttonMain'
            >
              <HiPlus size={20} />
            </Button>
          </div>
        )}
        <div className='w-full p-4'>
          <div className='relative'>
            {isLoading && <Loader />}
            <ClientLocationListTable
              data={locationListData}
              deleteClientLocation={deleteClientLocation}
              editClientLocation={editClientLocation}
            />
          </div>
        </div>
      </div>
      <ClientLocationModal
        show={showModal}
        setShow={setShowModal}
        clientId={clientId}
        getClientLocations={getClientLocations}
        selectedClientLocation={selectedClientLocation}
      />
    </>
  );
}
